import { Action } from 'redux/action';
import { createAction } from 'redux/actions/creator';
import { WhoIsLoggedInActions, WhoIsLoggedInUser } from 'redux/reducers/whoIsLoggedInReducer';

export const setUsers = (
  users: readonly WhoIsLoggedInUser[]
): Action<WhoIsLoggedInActions, readonly WhoIsLoggedInUser[]> =>
  createAction(WhoIsLoggedInActions.SetUsers, users);
